/**
 * Icons referenced by the navigation tree.
 *
 * Listed explicitly rather than resolved dynamically off the whole icon
 * library: a dynamic lookup would pull every icon into the bundle, and a
 * typo in a name would fail silently at runtime instead of at build time.
 */

import {
  BadgeCheck, BarChart3, BookOpen, Boxes, Building, Building2,
  CalendarCheck, CalendarDays, CalendarRange, ChartNoAxesCombined, CheckCheck,
  CircleUser, ClipboardList, Cog, Coins, Contact, Factory, FileBarChart,
  FileCheck2, FileSignature, FileText, FolderTree, Gift, GitBranch,
  GraduationCap, HandCoins, Inbox, IndianRupee, Landmark, LayoutDashboard,
  ListChecks, ListTree, LogOut, MapPin, MessagesSquare, Navigation, Network, Package,
  PackageOpen, Percent, Receipt, ReceiptText, Route, ScrollText, Settings,
  ShieldCheck, ShoppingCart, Store, Tags, Target, TrendingUp, Truck, UserCog,
  UserPlus, Users, Warehouse, Waypoints, Wallet, Wrench, Zap,
  Rocket, Smartphone,
  BellRing, Banknote, Clock, Crosshair, Footprints, LayoutList, Megaphone, Radar, ReceiptIndianRupee, Settings2, UserRound, UsersRound,
  type LucideIcon,
} from 'lucide-react';

export const NAV_ICONS: Record<string, LucideIcon> = {
  BadgeCheck, BarChart3, BookOpen, Boxes, Building, Building2,
  CalendarCheck, CalendarDays, CalendarRange, ChartNoAxesCombined, CheckCheck,
  CircleUser, ClipboardList, Cog, Coins, Contact, Factory, FileBarChart,
  FileCheck2, FileSignature, FileText, FolderTree, Gift, GitBranch,
  GraduationCap, HandCoins, Inbox, IndianRupee, Landmark, LayoutDashboard,
  ListChecks, ListTree, LogOut, MapPin, MessagesSquare, Navigation, Network, Package,
  PackageOpen, Percent, Receipt, ReceiptText, Route, ScrollText, Settings,
  ShieldCheck, ShoppingCart, Store, Tags, Target, TrendingUp, Truck, UserCog,
  UserPlus, Users, Warehouse, Waypoints, Wallet, Wrench, Zap,
  BellRing, Banknote, Clock, Crosshair, Footprints, LayoutList, Megaphone, Radar, ReceiptIndianRupee, Settings2, UserRound, UsersRound, Rocket, Smartphone,
};

export function navIcon(name: string | undefined): LucideIcon | null {
  if (!name) return null;
  return NAV_ICONS[name] ?? null;
}
